import { useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  createCreation,
  uploadText,
  finalizeInput,
  dciError,
  INPUT_METHOD,
} from "../../Services/dialogueCreations";
import { CaptureHeader, CapturePage, useFocusedCaptureHeader, makeIdempotencyKey } from "./shared";
import { TEXT_COPY, errorText } from "./copy";

/** The server enforces this cap; the counter is a courtesy (guide §3.3). */
const MAX_CHARS = 50000;

/**
 * Type or Paste Text (Figma 9856:14745): create (TEXT) → POST artifacts/text
 * → finalize-input → the processing flow.
 */
function CaptureText() {
  const navigate = useNavigate();
  useFocusedCaptureHeader();
  const [text, setText] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState(null);
  const key = useRef(makeIdempotencyKey("text"));

  const submit = async () => {
    if (!text.trim() || busy) return;
    setBusy(true);
    setError(null);
    try {
      const creation = await createCreation(INPUT_METHOD.TEXT, key.current);
      const id = creation?.creation_request_id;
      await uploadText(id, text);
      await finalizeInput(id);
      navigate(`/capture/${encodeURIComponent(id)}`, { replace: true });
    } catch (e) {
      setError(errorText(dciError(e).code));
      setBusy(false);
    }
  };

  return (
    <CapturePage focused>
      <CaptureHeader title={TEXT_COPY.title} />
      <div className="cap-body">
        <div className="cap-textarea">
          <textarea
            value={text}
            onChange={(e) => setText(e.target.value.slice(0, MAX_CHARS))}
            placeholder={TEXT_COPY.placeholder}
            aria-label={TEXT_COPY.title}
            maxLength={MAX_CHARS}
          />
          <span className="cap-textarea__count">{TEXT_COPY.counter(text.length, MAX_CHARS)}</span>
        </div>
        {error && <p className="cap-error">{error}</p>}
        <button type="button" className="cap-btn" disabled={!text.trim() || busy} onClick={submit}>
          {TEXT_COPY.continue}
        </button>
      </div>
    </CapturePage>
  );
}

export default CaptureText;
